



























import { Component, Vue, Mixins } from 'vue-property-decorator';
import SideMenuItem from './SideNavigationParts/SideMenuItem.vue';
import CurrentUserService from '@/mixins/currentUser.service';

@Component({
  components: {
    SideMenuItem,
  },
  mixins: [ CurrentUserService ],
})
export default class SideNavigation extends Mixins(CurrentUserService) {
  private menuItems = {
    user: [
      { title: 'Calendar', route: '/calendar', icon: 'mdi-calendar-blank' },
      { title: 'Requests', route: '/requests', icon: 'mdi-view-list' },
    ],
    admin: [
      { title: 'Users', route: '/admin/users', icon: 'mdi-account-multiple' },
      { title: 'Leave Types', route: '/admin/leave-types', icon: 'mdi-tag-multiple' },
    ],
  };

}
